import WaterDamageOutlinedIcon from '@mui/icons-material/WaterDamageOutlined';
import OfflineBoltOutlinedIcon from '@mui/icons-material/OfflineBoltOutlined';
import BathroomOutlinedIcon from '@mui/icons-material/BathroomOutlined';
import AssignmentTurnedInOutlinedIcon from '@mui/icons-material/AssignmentTurnedInOutlined';
import TableChartOutlinedIcon from '@mui/icons-material/TableChartOutlined';
import ConstructionOutlinedIcon from '@mui/icons-material/ConstructionOutlined';

export const defectsData = {
  header: {
    badge: {
      text: "Common Issues",
      icon: "WarningIcon"
    },
    title: "Common Defects Found in New Construction Homes",
    description: "Our professional home inspectors identify an average of 100+ defects in newly constructed homes. Early detection saves you thousands in repair costs and ensures your family's safety and comfort."
  },
  cards: [
    {
      title: 'Moisture & Water Damage',
      description: 'Water seepage, dampness in walls, ceiling leaks, and poor waterproofing that can lead to mold growth and structural damage.',
      icon: <WaterDamageOutlinedIcon className="defect-icon" />,
      color: '#10B981'
    },
    {
      title: 'Electrical Safety Hazards',
      description: 'Faulty wiring, improper grounding, non-functional switches, exposed electrical connections, and inadequate electrical panel installations.',
      icon: <OfflineBoltOutlinedIcon className="defect-icon" />,
      color: '#EF4444'
    },
    {
      title: 'Plumbing System Issues',
      description: 'Low water pressure, pipe leaks, faulty fixtures, improper drainage, and substandard plumbing material installations.',
      icon: <BathroomOutlinedIcon className="defect-icon" />,
      color: '#3B82F6'
    },
    {
      title: 'Surface & Paint Defects',
      description: 'Wall cracks, uneven surfaces, paint inconsistencies, poor finishing work, and visible construction joints.',
      icon: <AssignmentTurnedInOutlinedIcon className="defect-icon" />,
      color: '#8B5CF6'
    },
    {
      title: 'Carpentry & Woodwork Issues',
      description: 'Damaged doors and frames, loose hinges, warped wood, poor laminate work, and substandard hardware installations.',
      icon: <TableChartOutlinedIcon className="defect-icon" />,
      color: '#F59E0B'
    },
    {
      title: 'Window & Door Alignment',
      description: 'Improper window installations, gaps in frames, faulty locking mechanisms, poor sealing, and alignment issues.',
      icon: <ConstructionOutlinedIcon className="defect-icon" />,
      color: '#06B6D4'
    }
  ]
};
